import * as optimizelyReactSDK from '@optimizely/react-sdk'

const initOptimizely = () => {
  return optimizelyReactSDK.createInstance({
    sdkKey: process.env.GATSBY_API_OPTIMIZELY,
    logLevel: 'none',
    datafileOptions: {
      autoUpdate: true,
      updateInterval: 600000 // 10 minutes in milliseconds
    }
  })
}

export default initOptimizely
